import axios from "axios";


const USER_TEMPLATES_SERVICE_BASE = `${process.env.REACT_APP_API_URL}/collaboration-service/api/templates`;

const apiClient = axios.create({
  baseURL: USER_TEMPLATES_SERVICE_BASE,
  withCredentials: true,
});
// Add Authorization token to each request
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
const userTemplatesApi = {
  saveCollabTemplate: (formData) => {
    return apiClient.post("/save-template", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      responseType: "blob",
    });
  },

   getTemplatesByUserId: (userId, page , pageSize , sortedColumn , sortOrder ) => {
    return apiClient.get(`/templatesByUserId/${userId}`, {
      params: { page, pageSize, sortedColumn, sortOrder },
    });
  },
};

export default userTemplatesApi
